import { useState } from "react";

export default function useFetch() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const request = async (url, options = {}) => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(url, {
        ...options,
        headers: {
          token: localStorage.getItem("authToken"),
        },
      });

      const data = await res.json();
      return data;
    } catch (err) {
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { request, loading, error };
}